// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles-module--grid--eCTYU","product":"styles-module--product--2_i5M","title":"styles-module--title--DxyH6","price":"styles-module--price--p_9T0"};